import { bearingDistance, getHeatmapObjectsWithEpoch, getVehiclesWithEpoch } from "helper/crowds";
import * as turf from '@turf/turf';


function extractUniqueVehiclesFromStopDepartures(stops) {
    var vehicles = {};



    for (var stop_id in stops) {
        for (var departure of stops[stop_id].departures) {
            if (departure.vehicle_position) {
                vehicles[departure.vehicle_id] = {
                    position: departure.vehicle_position,
                    timestamp: departure.vehicle_timestamp
                }
            }
        }
    }

    return Object.values(vehicles);

}


function snapTramToLinemaps(tram, linemap) {
    // returns distance from point and distance along line

    const TRAM_WAGON_WIDTH = 2;
    const TRAM_WAGON_LENGTH = 10;
    const TRAM_WAGON_GAP = 0.5;
    const NO_OF_WAGONS = 4;


    var closest_line = null;
    // debugger;-33.91745403479278, 151.22592572160409

    if (tram.position.latitude <= -33.91745403479278) {
        // debugger;
    }


    for (var [index, feature] of linemap.features.entries()) {
        // debugger;
        var pt = turf.point([tram.position.longitude, tram.position.latitude]);

        var line = turf.lineString(feature.geometry.coordinates);
        var clean_line = turf.cleanCoords(line);
        // debugger;
        var snapped = turf.nearestPointOnLine(clean_line, pt, { units: "meters" });

        // if (closest_line != null) {
        //     console.log(closest_line.snapped.properties.dist > snapped.properties.dist)
        // }

        if (closest_line == null || closest_line.snapped.properties.dist > snapped.properties.dist) {

            closest_line = {
                clean_line: JSON.parse(JSON.stringify(clean_line)),
                snapped: JSON.parse(JSON.stringify(snapped)),
                index
            }
        }


    }



    // console.log(closest_line.snapped.properties)


    var points = [];

    var options = {
        units: "meters"
    }


    var distance = turf.distance(turf.along(closest_line.clean_line, snapped.properties.location, options), [tram.position.longitude, tram.position.latitude]);
    // console.log(distance)
    if (distance > 100) {
        debugger;
    }

    for (var x = 0; x < NO_OF_WAGONS; x++) {
        var back_of_carriage = turf.along(closest_line.clean_line, snapped.properties.location + (x * (TRAM_WAGON_LENGTH + TRAM_WAGON_GAP)), options);
        var center_of_carriage = turf.along(closest_line.clean_line, snapped.properties.location + (x * (TRAM_WAGON_LENGTH + TRAM_WAGON_GAP)) + (TRAM_WAGON_LENGTH / 2), options);
        var front_of_carriage = turf.along(closest_line.clean_line, snapped.properties.location + (x * (TRAM_WAGON_LENGTH + TRAM_WAGON_GAP)) + TRAM_WAGON_LENGTH, options);

        // debugger;
        points.push({
            point: center_of_carriage,
            bearing: turf.bearing(front_of_carriage, back_of_carriage)
        });
    }

    return points.map(function (row) {
        return convertPointToRectangle(row.point, row.bearing, TRAM_WAGON_LENGTH, TRAM_WAGON_WIDTH);
    })

}

function convertPointToRectangle(point, bearing, length, width) {

    var options = {
        units: "meters"
    }

    const front = turf.destination(
        point,
        length / 2, // Distance
        bearing,
        options
    );

    const back = turf.destination(
        point,
        length / 2, // Distance
        bearing + 180,
        options
    );

    const front_left = turf.destination(
        front,
        width / 2, // Distance
        bearing + 270,
        options
    );

    const front_right = turf.destination(
        front,
        width / 2, // Distance
        bearing + 90,
        options
    );

    const back_left = turf.destination(
        back,
        width / 2, // Distance
        bearing + 270,
        options
    );

    const back_right = turf.destination(
        back,
        width / 2, // Distance
        bearing + 90,
        options
    );

    // Calculate Corner 2 (perpendicular to the bearing, half the width)

    // debugger;

    var path = [front_left, front_right, back_right, back_left, front_left].map(r => r.geometry.coordinates)

    const rectangle = turf.polygon([path]);

    return rectangle;

}

function getPointWithPixels(x, y, max_distance, camera_metadata, fov) {



    var distance = Math.pow((1 - y), 2) * max_distance;
    // console.log(max_distance)
    // if (max_distance == 40) {
    //     console.log(distance)
    // }


    var distance_from_center = x - 0.5;

    var radians = Math.atan(distance_from_center / (1 - y))

    var bearing = radians * (180 / Math.PI);

    // console.log(bearing)

    bearing *= (fov / 90)

    return bearingDistance(camera_metadata.position.latitude, camera_metadata.position.longitude, distance, (camera_metadata.bearing + bearing % 360))
}

function getMatrixWithUUID(uuid) {

    let srcPoints, dstPoints;

    switch (uuid) {
        case '123':
            srcPoints = cv.matFromArray(6, 1, cv.CV_32FC2, [
                100, 200,  // pixel 1
                300, 400,  // pixel 2
                500, 450,  // pixel 3
                600, 250,  // pixel 4
                700, 350,  // pixel 5
                800, 300   // pixel 6
            ]);

            dstPoints = cv.matFromArray(6, 1, cv.CV_32FC2, [
                0, 0,      // ground 1 (m)
                5, 0,      // ground 2
                5, 5,      // ground 3
                0, 5,      // ground 4
                2.5, 2.5,  // ground 5
                6, 4       // ground 6
            ]);
    }


    const H = cv.findHomography(srcPoints, dstPoints, cv.RANSAC);

    return H;
}

function getBearingDistanceWithPixelAndUUID(uuid, x, y, width, height) {

    const H = getMatrixWithUUID(uuid);

    // // Example usage:
    // const H = [
    //     [0.0023, 0.0001, -0.45],
    //     [0.0002, 0.0021, -0.30],
    //     [0.000001, 0.000002, 1.0]
    // ];

    const pixel = { u: 620, v: 480 };
    const result = pixelToBearingDistance(H, pixel.u, pixel.v);

    console.log(`Ground X,Y: (${result.X.toFixed(2)}, ${result.Y.toFixed(2)})`);
    console.log(`Distance: ${result.distance.toFixed(2)} m`);
    console.log(`Bearing: ${(result.bearing * 180 / Math.PI).toFixed(1)}°`);

}



/**
 * Compute bearing and distance from a pixel using homography.
 *
 * @param {number[][]} H - 3x3 homography matrix (image → ground plane)
 * @param {number} u - pixel x coordinate
 * @param {number} v - pixel y coordinate
 * @param {number} [X0=0] - reference X position (e.g. camera position)
 * @param {number} [Y0=0] - reference Y position (e.g. camera position)
 * @returns {{X: number, Y: number, distance: number, bearing: number}} ground coordinates + metrics
 */
function pixelToBearingDistance(H, u, v, X0 = 0, Y0 = 0) {
    // Convert (u, v, 1) through homography
    const denom = H[2][0] * u + H[2][1] * v + H[2][2];
    const X = (H[0][0] * u + H[0][1] * v + H[0][2]) / denom;
    const Y = (H[1][0] * u + H[1][1] * v + H[1][2]) / denom;

    // Compute distance and bearing relative to reference point
    const dx = X - X0;
    const dy = Y - Y0;
    const distance = Math.sqrt(dx * dx + dy * dy);
    const bearing = Math.atan2(dy, dx); // radians (convert to degrees if needed)

    return { X, Y, distance, bearing };
}


function getSmallBarGraphData(data, uuid, epoch, area) {
    var device_data = data.filter(function (r, index) { return (r.uuid == uuid) });

    var data_points_before_epoch = device_data.filter(function (r, index) { return (r.start < epoch) });

    if (data_points_before_epoch.length < 10) {
        var chart_data = device_data.slice(0, 10);
    }
    else {
        var chart_data = data_points_before_epoch.slice(-10);
    }

    chart_data = chart_data.map(function (r) {
        // console.log(r)
        return {
            x: new Date(r.start * 1000),
            y: r.mean,
            density: Math.round((r.mean / area) / 0.003)
        }
    })

    return chart_data;
}

function calculateLinearTrend(data) {
    const n = data.length;

    if (n < 2) {
        // Cannot calculate a trend with less than 2 data points
        return { slope: 0, intercept: 0, trendLine: [] };
    }

    // Calculate sums for linear regression
    let sumX = 0;
    let sumY = 0;
    let sumXY = 0;
    let sumX2 = 0;

    for (let i = 0; i < n; i++) {
        const x = i; // Assuming x-values are indices (0, 1, 2, ...)
        const y = data[i];

        sumX += x;
        sumY += y;
        sumXY += x * y;
        sumX2 += x * x;
    }

    // Calculate slope (m) and y-intercept (b)
    const slope = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
    const intercept = (sumY - slope * sumX) / n;

    // Generate the trend line values
    const trendLine = [];
    for (let i = 0; i < n; i++) {
        trendLine.push(slope * i + intercept);
    }

    return { slope, intercept, trendLine };
}


export default function (crowdCounting, event, device_uuids, epoch) {

    //return schema
    var map_data = {
        heatmap: [],
        gtfs: {
            trams: {
                departures: {},
                vehicle_positions: []
            },
            buses: {
                departures: {},
                vehicle_positions: []
            }
        },
        camera_points: [],
        camera_polygons: [],
        count: 0
    };

    // debugger;

    if (crowdCounting) {
        // debugger;
        var filtered_heatmap_objects = getHeatmapObjectsWithEpoch(crowdCounting.heatmap, epoch);
        var filtered_descriptions = getHeatmapObjectsWithEpoch(crowdCounting.descriptions, epoch);

        // console.log()
        var tram_departures = crowdCounting.tram_stops ? getVehiclesWithEpoch(crowdCounting.tram_stops, epoch) : [];

        map_data.gtfs.trams.departures = {
            southbound: [],
            northbound: []
        }

        if (typeof tram_departures[2021101] != 'undefined') {
            map_data.gtfs.trams.departures.northbound = tram_departures[2021101].departures;
        }

        if (typeof tram_departures[2021102] != 'undefined') {
            map_data.gtfs.trams.departures.southbound = tram_departures[2021102].departures;
        }

        var bus_departures = crowdCounting.bus_stops ? getVehiclesWithEpoch(crowdCounting.bus_stops, epoch) : [];
        var all_departures = Object.values(bus_departures).map(r => r.departures);

        map_data.gtfs.buses.departures = [].concat(...all_departures);



        map_data.gtfs.trams.vehicle_positions = extractUniqueVehiclesFromStopDepartures(tram_departures);
        map_data.gtfs.buses.vehicle_positions = extractUniqueVehiclesFromStopDepartures(bus_departures);

        map_data.gtfs.buses.vehicle_positions = map_data.gtfs.buses.vehicle_positions.map(function (row) {
            row.box = convertPointToRectangle([row.position.longitude, row.position.latitude], row.position.bearing, 12, 2.5);
            return row;
        })



        map_data.gtfs.trams.vehicle_positions = map_data.gtfs.trams.vehicle_positions.map(function (row) {
            row.snapped = snapTramToLinemaps(row, event.route_shapes);
            return row;

        })


        for (var location of event.locations) {

            if (device_uuids.indexOf(location.uuid) >= 0) {

                // debugger;

                var area = turf.area(location.geojson)

                var preview_graph = getSmallBarGraphData(crowdCounting.graph, location.uuid, epoch, area)

                var camera_metadata = {
                    ...location,
                    bearing: location.cameras[0].bearing,
                    timestamp: 0,
                    count: 0,
                    preview_graph,
                    density: 0,

                };

                var trend = calculateLinearTrend(preview_graph.map(r => r.y))


                camera_metadata.change = trend.slope / 100;


                if (camera_metadata.geojson) {
                    map_data.camera_polygons.push(location);

                }

                if (filtered_descriptions[location.uuid]) {
                    camera_metadata.description = filtered_descriptions[location.uuid];
                }

                if (filtered_heatmap_objects[location.uuid]) {
                    camera_metadata.timestamp = filtered_heatmap_objects[camera_metadata.uuid].timestamp;
                    camera_metadata.count = filtered_heatmap_objects[camera_metadata.uuid].data.heatmap_count;
                    camera_metadata.source_id = filtered_heatmap_objects[camera_metadata.uuid].source_id;
                    camera_metadata.image_id = filtered_heatmap_objects[camera_metadata.uuid].id;
                    // var area = turf.area(camera_metadata.geojson)
                    camera_metadata.density = Math.round((camera_metadata.count / area) / 0.003);



                    map_data.count += camera_metadata.count;

                    var distance_cut_off = 0.2

                    let {max_distance, fov} = camera_metadata;

                    if(typeof max_distance == 'undefined'){
                        max_distance = 50;
                    }

                    if(typeof fov == 'undefined'){
                        fov = 60
                    }

                    for (var object of filtered_heatmap_objects[camera_metadata.uuid].data.objects) {

                        // debugger;


                        // var max_distance = 120;



                        if (object.y >= distance_cut_off) {
                            var x_margin_adjuster = object.x_m / 2;
                            var y_margin_adjuster = object.y_m / 2;

                            var t_l = getPointWithPixels(object.x - x_margin_adjuster, object.y - y_margin_adjuster, max_distance, camera_metadata, fov);
                            var t_r = getPointWithPixels(object.x + x_margin_adjuster, object.y - y_margin_adjuster, max_distance, camera_metadata, fov);
                            var b_l = getPointWithPixels(object.x - x_margin_adjuster, object.y + y_margin_adjuster, max_distance, camera_metadata, fov);
                            var b_r = getPointWithPixels(object.x + x_margin_adjuster, object.y + y_margin_adjuster, max_distance, camera_metadata, fov);

                            var heatmap_shape = [t_l, t_r, b_r, b_l, t_l];

                            var polygon = turf.polygon(
                                [
                                    heatmap_shape,
                                ],
                                { name: "poly1" },
                            );

                            var midpoint = turf.midpoint(t_l, b_r);
                            var area_of_polygon = turf.area(polygon)
                            // var percentage_of_area = Math.sqrt(Math.pow(area_of_polygon, 2) / Math.pow(area, 2));
                            var percentage_of_area = area_of_polygon / area;
                            var percentage_of_count = object.w * 5;

                            var dist = turf.distance(t_l, midpoint);


                            // var percentage_of_heat = 

                            var radius = dist * 1000;

                            // console.log(weight * filtered_heatmap_objects[camera_metadata.uuid].data.heatmap_count)

                            // console.log(area_of_polygon, percentage_of_count, percentage_of_area)

                            // console.log(percentage_of_count * percentage_of_area * filtered_heatmap_objects[camera_metadata.uuid].data.heatmap_count)

                            map_data.heatmap.push({
                                weight: object.w,
                                area,
                                radius: dist,
                                polygon: midpoint,
                                uuid: camera_metadata.uuid,
                                strength: percentage_of_count * percentage_of_area,
                                radius: radius * 1.5,
                            });

                        }

                    }

                }

                map_data.camera_points.push(camera_metadata);
            }


        }

    }


    return map_data;


}